import { render, staticRenderFns } from "./ActionsFooter.vue?vue&type=template&id=42122ebc&"
import script from "./ActionsFooter.vue?vue&type=script&lang=js&"
export * from "./ActionsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports